import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, TextField } from '@material-ui/core';


import { withRouter } from 'react-router';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { isEditAreaDialogOpen } from '../../selectors/dialog.selector';
import { areaActions } from '../../actions/area.actions';

interface Props {
    isEditAreaDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    submitValue: (name: string) => Promise<void>
}


type State = {
    name?: string
}

class EditAreaDialog extends Component<Props, State> {
    state = {
        name:  ""
    }

    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
       const { submitValue, closeDialogValue } = this.props
       const { name } =this.state
    
       batch(() => {
            submitValue(name)
            closeDialogValue()
       })
    }

    async onNameChange(event: any) {
        
        const name = event.target.value

        this.setState({
            name
        });
    }

    render() {
        const { classes, isEditAreaDialogOpen } = this.props;
        const { name } = this.state

        return (
            <Dialog
                maxWidth='sm'
                fullWidth={true}
                open={isEditAreaDialogOpen}
                onBackdropClick={this.closeDialog.bind(this)}
            >
                <DialogContent>
                    <div style={{ backgroundColor: '' }} className={classes.NewDialogFormTitle}>
                        <p className={classes.NewDialogFormTitleText}>
                            Blueprint Info
                        </p>
                    </div>
                    <div className={classes.DialogFormContent} >
                        <TextField                             required={true}
                            defaultValue={name} fullWidth={true} id="filled-basic" label="Name" variant="filled" onChange={this.onNameChange.bind(this)} />

                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onConfirm} color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state: any) => ({
    isEditAreaDialogOpen: isEditAreaDialogOpen(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(areaActions.closedEditAreaDialog()),
        submitValue: (name: string) => dispatch(areaActions.changeArea(name))
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(EditAreaDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/EditAreaDialog.tsx